<template>
  <div class="search-form">
    <b-form @reset="reset" onsubmit="return false">
      <b-input-group size="sm">
        <b-form-input
          @keyup.enter="query"
          type="search"
          v-model.trim="form.keyword"
          :placeholder="
            $l('table_search_placeholder') || '店铺名称/业务类型/订单ID 搜索...'
          "
        />
        <b-input-group-append>
          <b-button-group>
            <b-button-group slot="reference">
              <b-button
                variant="link"
                size="sm"
                class="search-dropdown-button"
                squared
                @click="openAdvqueryDialog"
              >
                {{ $l('INDEX.advanced_search') || '高级搜索' }}
              </b-button>
              <b-button variant="primary" size="sm" @click="query">
                <i class="fa fa-search" />
              </b-button>
            </b-button-group>
          </b-button-group>
        </b-input-group-append>
        <slot :form="form"></slot>
      </b-input-group>
    </b-form>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_store') || '店铺'">
              <dict-select
                v-model="form.listStoreCode"
                url="/ecom/amz/store/select"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                clearable
                multiple
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_postedDate') || '时间范围'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.postedDateStart"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :picker-options="postedDateStartOptions"
                  />
                </el-col>
                <el-col class="text-center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.postedDateEnd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :picker-options="postedDateEndOptions"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_transactionType') || '业务类型'"
            >
              <el-select
                v-model="form.transactionType"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                clearable
                style="width:100%"
              >
                <el-option
                  v-for="option in transactionTypeOptions"
                  :key="option"
                  :label="option"
                  :value="option"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_orderId') || '订单ID'">
              <el-input
                v-model.trim="form.orderId"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_amzSkuNo') || 'SKU'">
              <el-input
                v-model.trim="form.amzSkuNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_goodsName') || 'SKU名称'">
              <el-input
                v-model.trim="form.goodsName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_amzSpuNo') || 'SPU'">
              <el-input
                v-model.trim="form.amzSpuNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_amzSpuName') || 'SPU名称'">
              <el-input
                v-model.trim="form.amzSpuName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
const initForm = {
  keyword: '',
  postedDateStart: dayjs()
    .subtract(1, 'month')
    .format('YYYY-MM-DD'),
  postedDateEnd: dayjs().format('YYYY-MM-DD'),
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      transactionTypeOptions: [
        'Order',
        'Refund',
        'Order+Refund',
        'All',
        'Others',
      ],
    }
  },
  computed: {
    postedDateStartOptions() {
      const self = this
      return {
        disabledDate(time) {
          const { postedDateEnd } = self.form
          return (
            time.getTime() > new Date().getTime() ||
            (postedDateEnd &&
              time.getTime() > dayjs(postedDateEnd).valueOf()) ||
            (postedDateEnd &&
              time.getTime() <
                dayjs(postedDateEnd)
                  .subtract(6, 'month')
                  .valueOf())
          )
        },
      }
    },
    postedDateEndOptions() {
      const self = this
      return {
        disabledDate(time) {
          const { postedDateStart } = self.form
          return (
            time.getTime() > new Date().getTime() ||
            (postedDateStart &&
              time.getTime() < dayjs(postedDateStart).valueOf()) ||
            (postedDateStart &&
              time.getTime() >
                dayjs(postedDateStart)
                  .add(6, 'month')
                  .valueOf())
          )
        },
      }
    },
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }

      const { postedDateStart, postedDateEnd } = this.form
      if (!postedDateStart && !postedDateEnd) {
        this.form.postedDateStart = dayjs()
          .subtract(6, 'month')
          .format('YYYY-MM-DD')
        this.form.postedDateEnd = dayjs().format('YYYY-MM-DD')
      } else if (!postedDateStart) {
        this.form.postedDateStart = dayjs(postedDateEnd)
          .subtract(6, 'month')
          .format('YYYY-MM-DD')
      } else if (!postedDateEnd) {
        const endDate = dayjs(postedDateStart).add(6, 'month')
        this.form.postedDateEnd =
          endDate.valueOf() > dayjs().valueOf()
            ? dayjs().format('YYYY-MM-DD')
            : endDate.format('YYYY-MM-DD')
      }
      this.$emit('query', { ...this.form })
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.search-form {
  max-width: 900px;
  padding-right: 30px;
}
</style>
